import React from 'react';
import { Menu, X, LogOut, Zap } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const LOGO_URL = "/logo.jpg";

export const MobileHeader = ({ isOpen, onToggle }) => {
    const { logout } = useAuth();

    const handleLogout = () => {
        logout();
    };

    return (
        <div className="mobile-header" data-testid="mobile-header">
            <div className="flex items-center gap-3">
                {/* Logo with glow effect */}
                <div className="relative">
                    <div className="absolute -inset-1 bg-[#5BA4A4] rounded-full blur-sm opacity-30" />
                    <img 
                        src={LOGO_URL} 
                        alt="The Cybernetics" 
                        className="relative w-9 h-9 rounded-full border border-[rgba(91,164,164,0.5)]"
                    />
                </div>
                <div className="flex flex-col">
                    <h2 className="text-sm font-bold text-[#5BA4A4] uppercase tracking-wider font-rajdhani">
                        Cybernetics
                    </h2>
                    <span className="text-[9px] text-gray-500 flex items-center gap-1">
                        <Zap size={8} className="text-green-400" />
                        <span className="text-green-400">LIVE</span>
                    </span>
                </div>
            </div>
            <div className="flex items-center gap-1">
                <button 
                    onClick={handleLogout}
                    className="p-2.5 text-red-400 hover:bg-red-400/10 rounded-lg transition-all duration-200 active:scale-95 min-w-[44px] min-h-[44px] flex items-center justify-center"
                    data-testid="mobile-logout-btn"
                    title="Logout"
                >
                    <LogOut size={18} strokeWidth={1.5} />
                </button>
                <button 
                    onClick={onToggle}
                    className={`p-2.5 rounded-lg transition-all duration-200 active:scale-95 min-w-[44px] min-h-[44px] flex items-center justify-center ${
                        isOpen 
                            ? 'bg-[#5BA4A4] text-black' 
                            : 'text-[#5BA4A4] hover:bg-[rgba(91,164,164,0.1)]'
                    }`}
                    data-testid="mobile-menu-btn"
                >
                    {isOpen ? <X size={22} strokeWidth={2} /> : <Menu size={22} strokeWidth={1.5} />}
                </button>
            </div>
        </div>
    );
};

export default MobileHeader;
